import { fromJS, Map, List } from 'immutable';

export function update(state, action) {
    const {tags} = action;
    let items = state.get('items') || Map();

    Object.keys(tags).forEach(tag => {
        if (tags[tag].values && tags[tag].values.length && typeof tags[tag].values[0] === 'string') {
            // Retrieved only IDs
            tags[tag] = {...tags[tag]};

            let it = items.getIn([tag, 'values']) || List();

            tags[tag].values = tags[tag].values.map(v => {
                let currentValue = it.find(vv => vv.get('id') === v);

                if (!currentValue) {
                    return {
                        id: v.id,
                        label: v.id,
                        isDefault: false
                    };
                }

                return currentValue;
            });
        }

        items = items.set(tag, (items.get(tag) || Map()).mergeDeep(fromJS(tags[tag])));
    });

    return state.set('items', items);
}
